<div>
<h6 style="color: red;">Warning : Please contact HR to complete your documentation</h6>
</div>